/**
 * 📋 TABLE WIDGET
 * ════════════════════════════════════════════════════════════════════════
 * 
 * Widget para tablas de datos (DETAIL).
 * Props mínimas, sin lógica de layout.
 */

import React from 'react';
import VirtualizedTable from '../../../shared/ui/VirtualizedTable';
import { formatTableCellValue } from '../../../shared/utils/formatters';
import { getTableColumnsCache } from '../../../shared/utils/seriesCache';
import type { ExecutiveWidget } from '../types';

interface TableWidgetProps {
  widget: ExecutiveWidget;
}

const TableWidget: React.FC<TableWidgetProps> = ({ widget }) => {
  
  if (!widget.data || widget.data.length === 0) {
    return <div className="widget-empty">Sin datos</div>;
  }

  const normalizedTitle = widget.title?.trim().toLowerCase();
  const isDetailedAbilityList = normalizedTitle === 'detailed ability list';
  const rowHeight = 40;
  const maxHeight = 400;
  const scrollThreshold = Math.floor(maxHeight / rowHeight);
  const disableVerticalScroll = isDetailedAbilityList && widget.data.length <= scrollThreshold;
  
  const columns = getTableColumnsCache(widget.id, widget.data);
  
  return (
    <div className="table-widget">
      <div className="table-header">
        <h3 className="widget-title">{widget.title}</h3>
        <span className="table-count">{widget.data.length} registros</span>
      </div>
      
      <VirtualizedTable
        columns={columns}
        data={widget.data}
        formatCellValue={formatTableCellValue}
        formatHeader={formatColumnName}
        maxCellLength={80}
        rowHeight={rowHeight}
        overscan={8}
        maxHeight={maxHeight}
        disableVerticalScroll={disableVerticalScroll}
        containerClassName="table-container"
        tableClassName="data-table"
      />
    </div>
  );
};

/**
 * Formatear nombre de columna (snake_case → Title Case)
 */
function formatColumnName(name: string): string {
  return name
    .replace(/_/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}

export default TableWidget;
